import { JOIN_FLOW_STEPS, MembershipTier } from '@/lib/constants/maverick';
import { IJoinFaq } from './faqHelpers';

export const joinFlowFaqs: Record<string, IJoinFaq> = {
  whatsIncluded: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  whatsIncludedWithTrial: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  canISwitch: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  doIReturn: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  howShouldIDecide: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  howDoesTrialPlanWork: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  canIStartWithTrial: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  canISwitchToNewest: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  howDoTrialPlanDeviceReturnsWork: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  whenDoesMembershipStart: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  whyIsWhoopMembership: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  howDoesLifetimeMembershipWork: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  willMyAccessoriesBeCompatible: {
    showIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
  },
  willTheSameAccBeCompatibleOPL: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  isMyDataPrivate: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  whatIsTheFamilyPlan: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  whatIsTheReturnPolicy: {
    hideIfTrial: true,
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      exclude: ['IN'],
    },
  },
  canFamilyMembersDifferMemberships: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
  },
  whatDataCanBeShared: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
  },
  howCanTeensBestUtilize: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
  },
  whatIsMinimumAge: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
  },
  canIGiftFamilyMem: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: true,
    },
  },
  hsaFsaEligible: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['US'],
    },
  },
  // <--------------- INDIA --------------->
  // India doesn't have trials
  whatsIncludedIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  canISwitchIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  howShouldIDecideIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  whenDoesMyMemStartIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  whyIsWhoopMemIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  howDoesLifetimeWarWorkIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  willTheSameAccBeCompatibleOPLIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  isMyDataPrivateIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  whatIsTheReturnPolicyIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  willIBeChargedCustomsIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: true,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: true,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
  willINeedToArrangeDeliveryIN: {
    pages: {
      [JOIN_FLOW_STEPS.JOIN]: false,
      [JOIN_FLOW_STEPS.MEMBERSHIP]: false,
      [JOIN_FLOW_STEPS.FAMILY]: false,
    },
    countries: {
      include: ['IN'],
    },
  },
};
